module.exports = __webpack_public_path__ + "img/hero-4.45429a89.png";